import React from "react";
import SubNavigation from "../SubNavigation";
import AccountSubNavigation from "./AccountSubNavigation";
import AccountIcon from "./AccountIcon";

const AccountNavigation = ({ loading, user, selectMenu, renderSubNav }) => {
  const handleCloseMenu = () => {
    selectMenu(null);
  };
  return (
    <>
      <AccountIcon
        loading={loading}
        user={user}
        onUserMenu={() => selectMenu("account")}
      />
      {renderSubNav("account")(
        <SubNavigation appearance="aside" onClose={handleCloseMenu}>
          {user && (
            <AccountSubNavigation user={user} onCloseMenu={handleCloseMenu} />
          )}
        </SubNavigation>
      )}
    </>
  );
};

export default AccountNavigation;
